import { TutorialStatus } from "@/types";

export const statusFormLabels = [
    [TutorialStatus.Pending, " 📝 Pendiente", "default"],
    [TutorialStatus.InProgress, " ⏳ En Proceso", "info"],
    [TutorialStatus.NotApplicable, " 🚫 No Aplica", "error"],
    [TutorialStatus.Published, " ✅ Publicado", "success"],
] as const;


export const statusLabels = [
    [TutorialStatus.Pending, "Pendiente", "default"],
    [TutorialStatus.InProgress, "En Proceso", "info"],
    [TutorialStatus.NotApplicable, "No Aplica", "error"],
    [TutorialStatus.Published, "Publicado", "success"],
] as const;